var _jsxFileName = "/codebuild/output/src3324671287/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/consents/RWEConsent.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IconBack, InformationalScreen, LoadingModal, Stack } from '@adc/parallax-component-library';
import { APP_RETURN_TIMEOUT, ApiStatus, ErrorCode } from 'Constants';
import axios from 'axios';
import { useApiError } from 'Hooks';
import { Button, Footer, MainContainer, OptInOut, RichText } from 'Components/utility';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import { getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { logout } from 'Utilities/session';
import { store } from 'Utilities/store';
import { handleConsent } from 'Services/consent';
const mapStateToProps = ({
  env: {
    osType,
    osVersion,
    app,
    appVersion,
    phoneLanguage
  },
  auth,
  nav: {
    query
  },
  config: {
    documentUrls,
    documentPaths
  }
}) => {
  var _documentPaths$cms;
  return {
    osType,
    osVersion,
    app,
    appVersion,
    auth,
    isAccountProfile: !!query.accountProfile,
    cmsStrapiDomain: documentUrls.cmsStrapi,
    rweCmsPaths: (_documentPaths$cms = documentPaths.cms) === null || _documentPaths$cms === void 0 ? void 0 : _documentPaths$cms.rwelibre,
    phoneLanguage
  };
};
const connector = connect(mapStateToProps);
const RWEConsent = ({
  osType,
  osVersion,
  isAccountProfile,
  app,
  appVersion,
  auth,
  cmsStrapiDomain,
  rweCmsPaths,
  phoneLanguage
}) => {
  var _auth$include$patient2;
  const [loading, setLoading] = useState(true);
  const [isConsentOutdated, setIsConsentOutdated] = useState(false);
  const [rweBodyText, setRweBodyText] = useState('');
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const handleFetchingError = useCallback(() => {
    if (isAccountProfile) {
      showNetworkErrorModal();
      mediator.publish('router:back');
      return;
    }
    setRweBodyText('Research.content.researchRichText.bodyText');
  }, [isAccountProfile, showNetworkErrorModal]);
  const fetchRweConsentText = useCallback(async () => {
    try {
      var _data$Research, _auth$include$patient;
      const rweCmsUrl = getDocumentPathFromLanguage(rweCmsPaths, phoneLanguage);
      const rweCmsFullDomain = `${cmsStrapiDomain}${rweCmsUrl}`;
      const response = await axios.get(rweCmsFullDomain);
      const data = response.data;
      if (!(data !== null && data !== void 0 && (_data$Research = data.Research) !== null && _data$Research !== void 0 && (_data$Research = _data$Research.content) !== null && _data$Research !== void 0 && (_data$Research = _data$Research.researchRichText) !== null && _data$Research !== void 0 && _data$Research.bodyText)) {
        handleFetchingError();
        setLoading(false);
        return;
      }
      setRweBodyText(data.Research.content.researchRichText.bodyText);
      if (isAccountProfile && (_auth$include$patient = auth.include.patient.consents) !== null && _auth$include$patient !== void 0 && _auth$include$patient.realWorldEvidence) {
        const {
          at,
          latestVersion
        } = auth.include.patient.consents.realWorldEvidence;
        const isOutdated = at < latestVersion;
        if (isOutdated) {
          store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
              details: i18n.t('Consents.modals.reviewConsent.body'),
              testID: 'ReviewConsent'
            }
          });
          setIsConsentOutdated(true);
        }
      }
    } catch {
      handleFetchingError();
    } finally {
      setLoading(false);
    }
  }, [rweCmsPaths, phoneLanguage, cmsStrapiDomain, isAccountProfile, auth.include.patient.consents.realWorldEvidence, handleFetchingError]);
  useEffect(() => {
    fetchRweConsentText();
  }, [fetchRweConsentText]);
  const handleClickLink = href => {
    mediator.publish('router:navigate', href);
  };
  const handleApiRequestError = useCallback(error => {
    switch (error.status) {
      case ApiStatus.UNAUTHORIZED:
        logout();
        break;
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [showApiErrorModal, showNetworkErrorModal]);
  const handleConsentWrapper = useCallback(async action => {
    return new Promise((resolve, reject) => {
      handleConsent(auth.account_id, action, osType, osVersion, app, appVersion, 'realWorldEvidence').then(resp => {
        const updatedAuthSession = {
          ...auth,
          include: {
            patient: {
              ...auth.include.patient,
              consents: {
                ...auth.include.patient.consents,
                realWorldEvidence: {
                  ...resp
                }
              }
            }
          }
        };
        store.dispatch({
          type: AUTH_SESSION,
          authSession: updatedAuthSession
        });
        notifyApp('adc-webview:consents', {
          id: 'realWorldEvidence',
          action,
          location: isAccountProfile ? 'profile' : 'registration'
        });
        resolve(updatedAuthSession);
      }).catch(error => {
        handleApiRequestError(error);
        reject(error);
      });
    });
  }, [app, appVersion, auth, handleApiRequestError, isAccountProfile, osType, osVersion]);
  const handleSubmitRWEAction = useCallback(async action => {
    try {
      setLoading(true);
      const updatedAuthSession = await handleConsentWrapper(action);
      notifyApp('adc-webview:signin', updatedAuthSession);
      setIsConsentOutdated(false);
      if (isAccountProfile) {
        // Ends the loading state if the user is on the account profile page
        setLoading(false);
        return;
      }

      // This timeout is added to give the app time to redirect the user back.
      setTimeout(() => {
        setLoading(false);
      }, APP_RETURN_TIMEOUT);
    } catch (err) {
      setLoading(false);
    }
  }, [handleConsentWrapper, isAccountProfile]);
  const onClosePressed = useCallback(() => {
    mediator.publish('router:back');
  }, []);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      animatedTitle: true,
      title: i18n.t('Research.title'),
      buttonStart: isAccountProfile && !isConsentOutdated ? {
        element: /*#__PURE__*/React.createElement(IconBack, {
          testID: 'Research.close-Pressable',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 232,
            columnNumber: 28
          }
        }),
        label: i18n.t('Research.close'),
        onPress: onClosePressed
      } : undefined
    },
    testID: "Research",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 241,
      columnNumber: 11
    }
  }, rweBodyText.length > 0 && /*#__PURE__*/React.createElement(RichText, {
    testID: "Research.content.researchRichText.bodyText",
    onPressLink: handleClickLink,
    text: rweBodyText,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 11
    }
  }, isConsentOutdated || !isAccountProfile ? /*#__PURE__*/React.createElement(Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    alignSelf: "flex-end",
    width: "100%",
    gap: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 253,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: () => handleSubmitRWEAction('accept'),
    testID: "RWE.optIn",
    label: i18n.t('Global.microcopy.common.optIn'),
    "aria-label": i18n.t('Global.microcopy.common.optIn'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 254,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    onPress: () => handleSubmitRWEAction('decline'),
    label: i18n.t('Global.microcopy.common.decline'),
    "aria-label": i18n.t('Global.microcopy.common.decline'),
    testID: "Global.microcopy.common.decline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 260,
      columnNumber: 19
    }
  }))) : /*#__PURE__*/React.createElement(OptInOut, {
    optionStrings: {
      titleTag: 'Global.microcopy.common.status',
      positiveTag: 'Global.microcopy.common.optedIn',
      negativeTag: 'Global.microcopy.common.declined',
      positiveOption: 'Global.microcopy.common.optIn',
      negativeOption: 'Global.microcopy.common.decline'
    },
    initialState: !!((_auth$include$patient2 = auth.include.patient) !== null && _auth$include$patient2 !== void 0 && (_auth$include$patient2 = _auth$include$patient2.consents) !== null && _auth$include$patient2 !== void 0 && (_auth$include$patient2 = _auth$include$patient2.realWorldEvidence) !== null && _auth$include$patient2 !== void 0 && _auth$include$patient2.accepted) ? 'accept' : 'decline',
    handleConsent: handleConsentWrapper,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 15
    }
  })))));
};
export default connector(RWEConsent);